import useIPA from '@/auth/jwt/useDevice'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 10,
  pageOptions: [10, 20, 50],
  totalRows: 1,
  sortOptions: [],
  fields: [
    { key: 'name', label: 'location', sortable: true },
    { key: 'latitude', label: 'latitude' },
    { key: 'longitude', label: 'longitude' },
    { key: 'company_name', label: 'Company' },
    { key: 'partner_name', label: 'Partner' },
    { key: 'project_name', label: 'Project' },
    { key: 'site_name', label: 'Site' },
    { key: 'area_name', label: 'Area' },
    { key: 'created_at', label: 'Created At' },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action' },
  ],
  items: [],
})

// getters
const getters = {}

// actions
const actions = {
  getAll({ commit }, params) {
    const param = { status: 'master/locations', params }
    useIPA.get(param).then(response => {
      const location = {
        rows: response.data.data,
      }
      const { pagination } = response.data
      commit('setData', { ...location })
      commit('setPagination', pagination)
    })
  },
  getById({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/location/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  formPostPut({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = {
        area_id: formData.select_1,
        name: formData.text_1,
        description: formData.text_2,
        latitude: formData.text_3,
        longitude: formData.text_4,
      }
      const param = { rawData, url: 'internal/master/location', id: formData.id }
      useIPA.postput(param)
        .then(response => {
          router.push({ name: 'data-location' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  remove({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { url: 'internal/master/location', id }
      useIPA.delete(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
}

// mutations
const mutations = {
  setData(state, location) {
    state.items = location.rows
    state.totalRows = location.rows.length
    state.options = []
    for (let i = 0; i < location.rows.length; i++) {
      const option = []
      for (const key in location.rows[i]) {
        if (key === 'id') {
          option.value = location.rows[i][key]
        } else if (key === 'name') {
          option.title = location.rows[i][key]
        } else if (key === 'id') {
          option.oid = location.rows[i][key]
        }
      }
      state.options.push({ ...option })
    }
  },
  setPagination(state, pagination) {
    state.perPage = pagination.limit
    state.totalRows = pagination.total_items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
